module.exports = __webpack_public_path__ + "media/img/apple-touch-icon-ipad3-10ad4b5d2e039f99e6056a5f1bc66378.png";